/**
 * Preferencias Hanging Protocols (PREMIUM/developer).
 * - enabled: master ON/OFF (default OFF)
 * - autoApply: al cargar estudio si master ON (default ON)
 */

export const HANGING_ENABLED_KEY = 'udv.hanging.enabled'
export const HANGING_AUTO_APPLY_KEY = 'udv.hanging.autoApply'

/**
 * Master switch. @returns {boolean} default false
 */
export function loadHangingEnabledPref() {
  try {
    if (typeof localStorage === 'undefined') return false
    const v = localStorage.getItem(HANGING_ENABLED_KEY)
    if (v == null || v === '') return false
    if (v === '1' || v === 'true' || v === 'on') return true
    return false
  } catch (e) {
    return false
  }
}

/**
 * @param {boolean} enabled
 */
export function saveHangingEnabledPref(enabled) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(HANGING_ENABLED_KEY, enabled ? '1' : '0')
  } catch (e) {
    /* ignore */
  }
}

/**
 * @returns {boolean} default true (solo aplica si master ON)
 */
export function loadHangingAutoApplyPref() {
  try {
    if (typeof localStorage === 'undefined') return true
    const v = localStorage.getItem(HANGING_AUTO_APPLY_KEY)
    if (v == null || v === '') return true
    if (v === '0' || v === 'false' || v === 'off') return false
    return true
  } catch (e) {
    return true
  }
}

/**
 * @param {boolean} enabled
 */
export function saveHangingAutoApplyPref(enabled) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(HANGING_AUTO_APPLY_KEY, enabled ? '1' : '0')
  } catch (e) {
    /* ignore */
  }
}
